import { render } from "./Listing.vue?vue&type=template&id=236c0b6f&ts=true"
import script from "./Listing.vue?vue&type=script&lang=ts"
export * from "./Listing.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__